import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cea6e28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container user-container" }
const _hoisted_2 = { class: "title-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main-title" }, "项目组", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新建项目组")
const _hoisted_5 = { class: "biz-card order-table" }
const _hoisted_6 = { class: "group-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1644465662059",
    class: "icon",
    viewBox: "0 0 1097 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "2056",
    width: "64",
    height: "64"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M338.857143 512q-92.571429 2.857143-151.428572 73.142857H110.857143q-46.857143 0-78.857143-23.142857T0 494.285714q0-201.714286 70.857143-201.714285 3.428571 0 24.857143 12t55.714285 24.285714T219.428571 341.142857q38.285714 0 76-13.142857-2.857143 21.142857-2.857142 37.714286 0 79.428571 46.285714 146.285714z m612 364q0 68.571429-41.714286 108.285714t-110.857143 39.714286H298.857143q-69.142857 0-110.857143-39.714286T146.285714 876q0-30.285714 2-59.142857t8-62.285714T171.428571 692.571429t24.571429-55.714286 35.428571-46.285714 48.857143-30.571429T344 548.571429q5.714286 0 24.571429 12.285714t41.714285 27.428571 61.142857 27.428572 77.142858 12.285714 77.142857-12.285714 61.142857-27.428572 41.714286-27.428571 24.571428-12.285714q34.857143 0 63.714286 11.428571t48.857143 30.571429 35.428571 46.285714 24.571429 55.714286 15.142857 62 8 62.285714 2 59.142857zM365.714286 146.285714q0 60.571429-42.857143 103.428572t-103.428572 42.857143-103.428571-42.857143-42.857143-103.428572 42.857143-103.428571T219.428571 0t103.428572 42.857143 42.857143 103.428571z m402.285714 219.428572q0 90.857143-64.285714 155.142857T548.571429 585.142857 393.428571 520.857143 329.142857 365.714286t64.285714-155.142857T548.571429 146.285714t155.142857 64.285715T768 365.714286z m329.142857 128.571428q0 44.571429-32 67.714286t-78.857143 23.142857h-76.571428q-58.857143-70.285714-151.428572-73.142857 46.285714-66.857143 46.285715-146.285714 0-16.571429-2.857143-37.714286 37.714286 13.142857 76 13.142857 33.714286 0 68-12.285714t55.714285-24.285714 24.857143-12q70.857143 0 70.857143 201.714285z m-73.142857-348q0 60.571429-42.857143 103.428572t-103.428571 42.857143-103.428572-42.857143-42.857143-103.428572 42.857143-103.428571 103.428572-42.857143 103.428571 42.857143 42.857143 103.428571z",
      "p-id": "2057",
      fill: "#8a8a8a"
    })
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "描述：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr-line" }, null, -1))
const _hoisted_10 = { class: "group-bottom" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = { class: "dialog-block" }
const _hoisted_14 = { style: {"text-align":"center"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_transfer = _resolveComponent("el-transfer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _createVNode(_component_el_form, {
          inline: "true",
          onsubmit: "return false"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.search,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  placeholder: "请输入用户名或邮箱",
                  onChange: _ctx.searchGroup,
                  onKeyup: _withKeys(_ctx.searchGroup, ["enter"])
                }, null, 8, ["modelValue", "onChange", "onKeyup"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.addGroup
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (group) => {
          return (_openBlock(), _createElementBlock("div", {
            key: group.id,
            class: "group-block"
          }, [
            _hoisted_7,
            _createElementVNode("div", null, [
              _createElementVNode("p", null, "名称：" + _toDisplayString(group.proGroupName), 1),
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", null, " 报告：" + _toDisplayString(group.contentTotal) + "     用户：" + _toDisplayString(group.userTotal), 1),
                _createElementVNode("p", null, [
                  _createVNode(_component_el_button, {
                    size: "mini",
                    onClick: ($event: any) => (_ctx.editGroup(group))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    size: "mini",
                    onClick: ($event: any) => (_ctx.deleteConfirm(group))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      width: "65%",
      modelValue: _ctx.isShowDialog,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isShowDialog) = $event)),
      title: _ctx.dialogTitle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "ruleForm",
              model: _ctx.dialogForm,
              inline: "true",
              rules: _ctx.rules
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          style: {"width":"60%"},
                          "label-width": "140px",
                          label: "项目组名称：",
                          prop: "proGroupName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.dialogForm.proGroupName,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogForm.proGroupName) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          style: {"width":"60%"},
                          "label-width": "140px",
                          label: "项目组描述：",
                          prop: "desc"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.dialogForm.desc,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogForm.desc) = $event)),
                              placeholder: "请输入内容"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      "label-width": "120px",
                      label: "添加成员："
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_transfer, {
                          modelValue: _ctx.checkedValue,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkedValue) = $event)),
                          style: {"text-align":"left","display":"inline-block"},
                          filterable: "",
                          titles: ['用户列表', '项目组成员'],
                          "button-texts": ['', ''],
                          format: {
                    noChecked: '${total}',
                    hasChecked: '${checked}/${total}',
                  },
                          data: _ctx.data
                        }, null, 8, ["modelValue", "data"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save(_ctx.dialogTitle)))
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: _ctx.cancelDialog }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}